<template>
  <div>
    <div class="page-body">
      <el-row :visible.sync="buttonVisible">
<div style="display: flex; justify-content: space-between" > 
        <div>
          <el-form
            :inline="true"
            class="demo-form-inline"
            label-position="right"
            label-width="100px"
            :model="searcheForm"
          >
            <el-form-item label="设备类型:" prop="feeType">
              <el-select
                v-model="searcheForm.equipmentType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in equipmentTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="桩号:">
              <el-input
                placeholder="请输入桩号"
                clearable
                width="200px"
                v-model="searcheForm.equipmentCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称:">
              <el-input
                placeholder="请输入桩名称"
                clearable
                width="200px"
                v-model="searcheForm.equipmentName"
              ></el-input>
            </el-form-item>

            <el-button
              icon="el-icon-search"
              type="primary"
              @click="listEquipments"
              >搜索</el-button
            >

            <el-button icon="el-icon-search" type="primary" @click="clearForm"
              >清空</el-button
            >
          </el-form>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView"
            >新增</el-button
          >
        </div>
      </div>
      </el-row>
      
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table
        :data="users"
        stripe
        border
        v-loading="loading"
        element-loading-text="正在加载..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <el-table-column
          prop="equipmentName"
          label="名称"
          fixed
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="equipmentCode"
          label="桩号"
          width="150"
          align="center"
          fixed=""
        ></el-table-column>
        <el-table-column
          prop="equipmentType"
          label="设备类型"
          width="100"
          align="center"
          :formatter="formatEquipmentType"
        ></el-table-column>

        <el-table-column
          prop="qrcodeImgUrl"
          label="二维码"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <div style="width: 70px; height: 70px; display: inline">
              <img
                :src="scope.row.qrcodeImgUrl"
                 @click="showImg(scope.row)"
                min-width="70"
                height="70"
                :preview-src-list="qrcodeImgUrl"
                placeholder="图片加载失败"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="plugA"
          label="插孔"
          width="350"
          align="center"
          :formatter="formatPlugB"
        >
          <template slot-scope="scope">
            <EquipmentStatusView :plugList="scope.row.plugList" :equipmentType="scope.row.equipmentType"/>
          </template>
        </el-table-column>

<!--        <el-table-column prop="plugB" label="插孔B" width="200" align="center">
          <template slot-scope="scope">
            <el-tag type="success">在线</el-tag>/<el-tag type="success"
              >空闲</el-tag
            >
          </template>
        </el-table-column> -->

        <el-table-column
          prop="remark"
          label="描述"
          width="500"
          align="center"
        ></el-table-column>
        <el-table-column fixed="right" width="300" align="center" label="操作">
          <template slot-scope="scope">
             <el-button size="mini"  @click="showChargingDialog(scope.row)"
              >充电操作</el-button
            >
            <el-button size="mini" @click="showImg(scope.row)">二维码</el-button>
            <el-button size="mini" @click="showEditEmpView(scope.row)">编辑</el-button>
            <el-button size="mini" @click="deleteUser(scope.row)" type="danger" style="display:none"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 表格 END -->

      <el-dialog
      :title="dialogImgTitle"
      :visible.sync="dialogImgVisible"
      width="300px"
    >
      <el-row>
        <div style="text-align: center">
          <span class="demonstration"
            ><h2> {{ currentViewCode }}</h2></span
          >
        </div>
      </el-row>
      <hr />
      <el-row>
        <div style="width: 95%; display: flex">
          <el-image :src="currentViewImg" width="100%"></el-image>
        </div>
      </el-row>
    </el-dialog>

    <!-- 表格 END -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1000px">
      <div>
        <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="所属站点:" prop="stationId">
            <el-select
              filterable
              style="width: 85%"
              v-model="form.chargeStationId"
              placeholder="请选择"
              @change="stationIdChange"
            >
              <el-option
                v-for="item in stationIdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备类型:" prop="equipmentType">
            <el-select
              style="width: 85%"
              v-model="form.equipmentType"
              placeholder="请选择"
              @change="equipmentTypeChange"
            >
              <el-option
                v-for="item in equipmentTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="网关:" prop="gatewayId" v-show="gatewayShow">
            <el-select
              style="width: 85%"
              v-model="form.gatewayId"
              placeholder="请选择"
              @change="gatewayOptionsChange"
            >
              <el-option
                v-for="item in gatewayOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="GatewayRemoteId:"
            prop="remoteGatewayId"
            style="display: none"
          >
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.remoteGatewayId"
              placeholder="请选择网关"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备名称:" prop="equipmentName">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.equipmentName"
              placeholder="请输入桩名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备编码:" prop="equipmentCode">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.equipmentCode"
              placeholder="请输入设备编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="IMEI码:" prop="imei">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.imei"
              placeholder="请输入IMEI码"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="MAC地址:"
            prop="macAddress"
            style="display: none"
          >
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.macAddress"
              placeholder="请输入MAC地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="插座数量:" prop="connectorNumber">
            <el-input
              type="number"
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.connectorNumber"
              placeholder="请输入插座数量"
            ></el-input>
          </el-form-item>

          <el-form-item label="建桩位置:" prop="address">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.address"
              placeholder="请输入建桩位置"
            ></el-input>
          </el-form-item>
          <el-form-item label="监控地址:" prop="monitorAddress">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.monitorAddress"
              placeholder="请输入监控地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="烟感:" prop="smokeDetector">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.smokeDetector"
              placeholder="请输入烟感"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAddUser">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="启动充电"
      :visible.sync="dialogStartVisible"
      width="600px"
    >
      <el-row>
        <el-form :model="startParams">
          <el-form-item label="设备名称">
            <span>{{ startParams.equipmentName }}</span>
          </el-form-item>
          <el-form-item label="设备编号">
            <span>{{ startParams.pileNo }}</span>
          </el-form-item>
          <el-form-item label="插座接口：">
              <el-radio-group v-model="startParams.port">
                <el-radio style="margin-top: 12px;"
                  :label="item.port"
                  :key="item.port"
                  v-for="item in business.portStatusList"
                  >{{ item.name }}
                 <template v-if="item.status==1"> <el-link type="success">在线</el-link></template>
                 <template v-if="item.status==2"> <el-link type="danger">占用（充电桩）</el-link></template>
                 <template v-if="item.status==3">禁用</template>
                 <template v-if="item.status==4">故障</template>
				 <template v-if="item.status==5">离线</template>
                  </el-radio
                >
              </el-radio-group>
            </el-form-item>

             <el-form-item label="选择时长：">
              <el-radio-group v-model="startParams.value">
                <el-radio style="margin-top: 12px;"
                  :label="item.hour"
                  :key="item.hour"
                  v-for="item in business.feeVOList"
                  >{{ item.hour }} 小时</el-radio
                >
              </el-radio-group>
            </el-form-item>
          <el-row>
            <el-col :span="12">
              &nbsp;
            </el-col>
             <el-col :span="12">
             <el-button @click="startCharging" type="primary">启动充电</el-button>
             </el-col>
            
          </el-row>
        </el-form>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteRequest,
  putRequest,
  getRequest,
  postRequest,
} from "../../utils/api";
import {
  apiListStations,
  apiListGatewayByStationId,
  apiListEquipmentsByStationId,
} from "./charge-equipment";
import EquipmentStatusView from './EquipmentStatusView.vue'
export default {
  name: "EquipmentTable",
  components:{EquipmentStatusView},
  data() {
    return {
      title: "", //模态窗口 标题
      dialogImgTitle: "二维码",
      searcheForm: {}, //搜索
      users: [], //列表数据
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      dialogImgVisible: false,
      stationIdOptions: [],
      gatewayOptions: [],
      buttonVisible:true,
      total: 0,
      page: 1,
      size: 10,
      stationId: null,
      gatewayId:null,
      parentCmp:'Default',
      gatewayShow: false,
      viewImgList: [],
      gatewayList: [],
      currentViewImg:null,
      currentViewCode:null,
      qrcodeImgUrl:null,
      dialogStartVisible: false,
      startParams: {
        pileNo: null,
        equipmentName: null,
        port: null,
        openId: "system_admin",
        optType:1,
        totalMoney:0,
        outTradeNo:'system_admin_operations:start',
        value:1,
      },
      business: {
        equipmentCode: null,
        equipmentName: null,
        portStatusList: [],
        feeVOList:[],
      },
      form: {
        equipmentType: 1,
        remoteGatewayId: null,
        gatewayId: null,
      },
      equipmentTypeOptions: [
        { label: "独立设备", value: 1 },
        { label: "组网设备", value: 2 },
      ],
      formRules: {
        equipmentCode: [
          { required: true, message: "请输桩id", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        imei: [
          { required: true, message: "请输IMEI码", trigger: "blur" },
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输建桩位置", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur",
          },
        ],
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        macAddress: [
          { required: false, message: "请输入设备MAC码", trigger: "blur" },
        ],
        connectorNumber: [
          { required: true, message: "请输入插座数量", trigger: "blur" },
        ],
        remark: [{ required: false, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  // mounted() {
  //   // this.listEquipments();
  //   // this.initSelectStations();
  // },
  props: {
    rootStationId: String,
  },
  mounted() {
    this.initSelectStations();
    this.$nextTick(function () {
      this.$on("listEquipments", function (v) {
        console.log("eqipment-table::" + JSON.stringify(v));
        this.stationId=v.stationId;
        this.gatewayId=v.gatewayId;
        this.parentCmp=v.parentCmp;
        if(v.gatewayId!=undefined){
          this.searcheForm.gatewayId = v.gatewayId;
        }
        if(v.buttonVisible!=undefined){
          this.buttonVisible=v.buttonVisible;
        }
        this.searcheForm.stationId = v.stationId;
        this.listEquipments();
      });

      // this.$on("listEquipmentsByGatewayId", function (v) {
      //   console.log("eqipment-table::gatewayId" + JSON.stringify(v));
      //   this.parentGatewayId = v.parentGatewayId;
      //   this.searcheForm.gatewayId = v.parentGatewayId;
      //   this.listEquipments();
      // });
    });
  },
  methods: {
    showChargingDialog(row) {
      this.dialogStartVisible = true;
      this.startParams.pileNo = row.equipmentCode;
      this.startParams.equipmentName=row.equipmentName;
      let qrcodeValue ="shhp.city/hpcd/?id="+row.equipmentCode;
      let params ={codeValue:qrcodeValue,openId:'system_admin'};
      postRequest('/charging/qr-scan',params).then((resp)=>{
        if(resp.status==200){
          this.business=resp.data;
        }
      })
    },
    startCharging() {
      console.log(JSON.stringify(this.startParams));
      postRequest('/charging/start',this.startParams).then((resp)=>{
        if(resp.status==200){
          this.$message({message:'执行成功',type:'success'});
        }
        if(!resp.status==200){
           this.$message({message:resp.msg,type:'error'});
        }
      })
    },
    stopCharging() {
      console.log(JSON.stringify(this.startParams));
    },
    clearForm() {
      this.searcheForm = {};
    },
    showImg(row) {
      this.dialogImgVisible = true;
      this.currentViewImg = row.qrcodeImgUrl;
      this.currentViewCode = row.equipmentCode;
    },
    listEquipments() {
      let data = this.searcheForm;
      apiListGatewayByStationId(data).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.gatewayList = data.list;
          this.total = data.total;
        }
      });
      let form = this.searcheForm;
      // form.stationId = this.stationId;
      console.log("查询站点下设备" + JSON.stringify(form));
      apiListEquipmentsByStationId(form).then((resp) => {
        this.loading = false;
        if (resp) {
          this.users = resp.data.list;
          this.total = resp.data.total;
        }
      });
    },
    formatGender(row, column) {
      return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
    },
    imgFormatter(row, column, cellValue, index) {},
    formatEquipmentType(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "独立设备";
      }
      if (cellValue == 2) {
        return "组网设备";
      }
    },
    formatPlugA(row, column, cellValue, index) {
      return "在线/空闲";
    },
    formatPlugB(row, column, cellValue, index) {
      return '在线/<el-tag type="success">标签二</el-tag>';
    },
    formatEnable(row, colum) {
      return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
    },
    // 添加用户按钮
    showAddEmpView() {
      this.form = {};
      this.title = "新增";
      this.dialogVisible = true;
	  this.form.chargeStationId=this.stationId
    },
    //编辑用户按钮
    showEditEmpView(data) {
      this.title = "编辑";
      this.form = data;
      this.dialogVisible = true;
    },
    // 删除用户
    deleteUser(data) {
      this.$confirm(
        "此操作将永久删除【" + data.equipmentName + "】, 是否继续?",
        "提示",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          deleteRequest(`/api/chargeEquipment/delEquipment/${data.id}`).then(
            (resp) => {
              if (resp) {
                this.listEquipments();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加卡 && 更新卡信息
    doAddUser() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          let url = "";
          let res;
          if (this.form.id) {
            url = `/api/chargeEquipment/updateEquipment`;
            res = putRequest(url, this.form);
          } else {
            url = `/api/chargeEquipment/addEquipment`;
            res = postRequest(url, this.form);
          }
          res.then((resp) => {
              if (resp.status == 200) {
                Message.success({ message: "操作成功" });
              } else {
                Message.error({ message: resp.msg });
              }
              if (resp) {
                this.dialogVisible = false;
                this.listEquipments();
              }
            })
            .catch((e) => {});
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.initCardList("advanced");
    },
    // 查询桩列表
    // listEquipments(type) {
    //   this.loading = true;
    //   let url =
    //     "/api/chargeEquipment/?page=" + this.page + "&size=" + this.size;
    //   getRequest(url, this.searcheForm).then((resp) => {
    //     this.loading = false;
    //     if (resp) {
    //       this.users = resp.data.list;
    //       this.total = resp.data.total;
    //     }
    //   });
    // },
    //
    changeGateway(stationId) {
      apiListGatewayByStationId({ stationId: stationId,size:66 }).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data.list;
           this.gatewayOptions=[];
          data.forEach((element) => {
            
            this.gatewayOptions.push({
              label: element.gatewayName + "-" + element.gatewayCode,
              value: element.id,
              remoteGatewayId: element.remoteGatewayId,
              remoteGatewaySn: element.gatewayCode,
            });
          });
        }
        this.form.gatewayId = this.gatewayOptions[0].value;
        this.form.remoteGatewayId = this.gatewayOptions[0].remoteGatewayId;
        this.form.remoteGatewaySn = this.gatewayOptions[0].remoteGatewaySn;
      });
    },
    gatewayOptionsChange(v) {
      const data = this.gatewayOptions;
      data.forEach((element) => {
        console.log(JSON.stringify(element));
        if (element.value == v) {
          this.form.remoteGatewayId = element.remoteGatewayId;
          this.form.remoteGatewaySn = element.remoteGatewaySn;
        }
      });
    },
    // 选择组网设备时加载网关信息
    equipmentTypeChange(v) {
      console.log("设备类型" + v);
      if (v == 1) {
        this.gatewayShow = false;
        this.form.gatewayId = null;
        this.form.remoteGatewaySn = null;
        this.form.remoteGatewaySn = null;
      }
      if (v == 2) {
        this.gatewayShow = true;
        const stationId = this.form.chargeStationId;
        this.changeGateway(stationId);
      }
    },
    // 站点切换之后操作
    stationIdChange(v) {
      console.log(
        "站点选择" + v + " 新增设备类型 ：" + this.form.equipmentType
      );
       this.stationIdOptions.forEach((element)=>{
        if(element.value==v){
          console.log('远程平台站点ID'+element.value+'-'+element.remoteSiteId);
          this.form.remoteSiteId=element.remoteSiteId;
        }
      })
      if (this.form.equipmentType == 2) {
        this.changeGateway(v);
      }
    },
    initSelectStations(stationId) {
      apiListStations({page:1,size:9999}).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.stationList.forEach((element) => {
            this.stationIdOptions.push({
              label: element.stationName,
              value: element.id,
              remoteSiteId:element.remoteSiteId
            });
            

          });
         
        }
      });
    },
    //
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>